export enum NoShowLateHandlingTypes {
  LATE_HANDL = "LATE_HANDL",
  NOSHOW = "NOSHOW",
  LATECANCEL = "LATECANCEL",
  LATECHANGE = "LATECHANGE",
}
